<template>
    <div class="edit__box__input__extra__images__img" @click="deleteImage">
        <div v-if="upload == true" class="loader__box__done"><img src="assets/done.png" alt=""></div>
        <div v-if="upload == false || upload == 'pending'" class="loader__box__loader"></div>
        <img :src="img" class="edit__box__input__extra__images__img__opacity" alt="">
    </div>
</template>
<script>
export default {
    props:["img", "id", "upload"],
    data(){
        return{
            selected: false,
            button: "edit__box__input__extra__images__img__button",
            image: ""
        }
    },
}
</script>